import React from "react";
import DashboardInterpretationsWeekly from "./DashboardInterpretationsWeekly";

const DashboardV2InterpretationsWeekly = ({ user }) => (
  <DashboardInterpretationsWeekly user={user} />
);

export default DashboardV2InterpretationsWeekly;
